/**
 * Component that generates and applies global font-face styles.
 *
 * This component uses the `@emotion/react` library to inject global styles for custom fonts.
 * It dynamically generates the `@font-face` CSS rules based on the `fontImports` configuration.
 *
 * @returns {JSX.Element} A React component that applies global font-face styles.
 */
import React from 'react'
import {Global} from '@emotion/react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {fontImports} from '../../theme/import/utils'

export const Fonts = () => {
    const fontFaceGenerate = () => {
        var importFontString = ''

        fontImports.forEach((font) => {
            font.variants.forEach((variant) => {
                const fileName = `${font.family}${variant.name}`
                const fontPath = `static/fonts/${font.folder}/${font.family}/${fileName}`
                importFontString += `
                @font-face {
                    font-family: '${font.family}';
                    src:  url(${getAssetUrl(`${fontPath}.woff2`)}) format('woff2');
                    font-display: swap;
                    font-weight: ${variant.weight};
                }
                `
            })
        })

        return importFontString
    }

    const generatedStyleForFonts = fontFaceGenerate()
    return <Global styles={generatedStyleForFonts} />
}
